var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommandesIndirectes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21cm",
    height: "21cm",
    viewBox: "358 538 405 405",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 360,
    y: 540,
    width: 400,
    height: 400
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 360,
    y: 540,
    width: 400,
    height: 400
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 400,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 400,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 440,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 440,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 480,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 480,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 520,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 520,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 560,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 560,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 600,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 600,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 640,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 640,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff"
    },
    x: 680,
    y: 680,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x: 680,
    y: 680,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 420,
    y: 665.875
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 420,
    y: 665.875
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 460,
    y: 665.875
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 460,
    y: 665.875
  }, "6"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 500,
    y: 665.875
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 500,
    y: 665.875
  }, "5"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 540,
    y: 665.875
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 540,
    y: 665.875
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 580,
    y: 665.875
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 580,
    y: 665.875
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 620,
    y: 665.875
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 620,
    y: 665.875
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 660,
    y: 665.875
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 660,
    y: 665.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 700,
    y: 665.875
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    y: 665.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 420,
    y: 705.875
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 420,
    y: 705.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 540,
    y: 705.875
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 540,
    y: 705.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 500,
    y: 705.875
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 500,
    y: 705.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 460,
    y: 705.875
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 460,
    y: 705.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 580,
    y: 705.875
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 580,
    y: 705.875
  }, "R/W"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 600,
    y1: 730,
    x2: 600,
    y2: 740
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 600,
    y1: 720,
    x2: 600,
    y2: 722
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 600,
    y1: 723.333,
    x2: 600,
    y2: 725.333
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 600,
    y1: 726.667,
    x2: 600,
    y2: 728.667
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 720,
    y1: 730,
    x2: 720,
    y2: 740
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 720,
    y1: 720,
    x2: 720,
    y2: 722
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 720,
    y1: 723.333,
    x2: 720,
    y2: 725.333
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 720,
    y1: 726.667,
    x2: 720,
    y2: 728.667
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 600,
    y1: 740,
    x2: 720,
    y2: 740
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 660,
    y1: 740,
    x2: 660,
    y2: 768
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "655,768 660,778 665,768 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "655,768 660,778 665,768 "
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 640,
    y: 805.875
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    y: 805.875
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 640,
    y: 825.875
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    y: 825.875
  }, "1"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 640,
    y: 845.875
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    y: 845.875
  }, "2"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 640,
    y: 865.875
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    y: 865.875
  }, "3"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 640,
    y: 885.875
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    y: 885.875
  }, "4"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 640,
    y: 905.875
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 640,
    y: 905.875
  }, "7"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 700,
    y: 805.875
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    y: 805.875
  }, "ROM"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 700,
    y: 825.875
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    y: 825.875
  }, "TGS"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 700,
    y: 845.875
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    y: 845.875
  }, "MAT"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 700,
    y: 865.875
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    y: 865.875
  }, "PAT"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 700,
    y: 885.875
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    y: 885.875
  }, "DOR"))), /*#__PURE__*/React.createElement("text", {
    fontSize: 16.9333,
    style: {
      fill: "#000000",
      textAnchor: "start",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 700,
    y: 905.875
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 700,
    y: 905.875
  }, "ROR"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 660,
    y1: 800,
    x2: 668,
    y2: 800
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "668,805 678,800 668,795 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "668,805 678,800 668,795 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 660,
    y1: 820,
    x2: 668,
    y2: 820
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "668,825 678,820 668,815 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "668,825 678,820 668,815 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 660,
    y1: 840,
    x2: 668,
    y2: 840
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "668,845 678,840 668,835 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "668,845 678,840 668,835 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 660,
    y1: 860,
    x2: 668,
    y2: 860
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "668,865 678,860 668,855 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "668,865 678,860 668,855 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 660,
    y1: 880,
    x2: 668,
    y2: 880
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "668,885 678,880 668,875 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "668,885 678,880 668,875 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    x1: 660,
    y1: 900,
    x2: 668,
    y2: 900
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "668,905 678,900 668,895 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      fillOpacity: 0,
      strokeWidth: 4,
      stroke: "#000000"
    },
    points: "668,905 678,900 668,895 "
  })), /*#__PURE__*/React.createElement("text", {
    fontSize: 28.2222,
    style: {
      fill: "#000000",
      textAnchor: "middle",
      fontFamily: "sans-serif",
      fontStyle: "normal",
      fontWeight: "normal"
    },
    x: 560,
    y: 592.136
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 560,
    y: 592.136
  }, "Commandes")), _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 560,
    y: 627.414
  }, "Indirectes"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandesIndirectes);
export default __webpack_public_path__ + "static/media/Commandes_indirectes.88aa285c197c3d0815bf9c22ad1f0abf.svg";
export { ForwardRef as ReactComponent };